<template>
    <v-container class="homepage-settings-content">

        <!-- Menu navigation list -->
        <!-- <v-navigation-drawer
            class="homepage-settings-nav-drawer pt-16"
            permanent
            touchless
            floating
            hide-overlay
            v-model="navDrawer"
        >
            <scrollactive
            ref="scrollactive"
            v-bind="activeScroll"
            style="border-right: 1px solid #EFDDD1"
            >
                <v-list nav dense>
                    <v-list-group
                        v-for="(item) in items"
                        :key="item.key"
                        no-action
                        v-model="item.active"
                        :append-icon="item.items.length ? '$expand' : ''"
                        :ripple="false"
                        :group="item.key"
                        :disabled="item.active"
                        @click="navigate(item.to)"
                        :class="{'active-section' : item.active, 'has-items': item.items.length}"
                        eager
                        >
                        <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title v-text="item.title"></v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            v-for="(item) in item.items"
                            :key="item.title"
                            replace
                            :ripple="false"
                            class="scrollactive-item mb-0"
                            :href="'#' + item.to.params.subsection"
                        >
                          <v-list-item-content class="subsection-content">
                            <v-list-item-title v-text="item.title"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </scrollactive>
        </v-navigation-drawer> -->

        <!-- Bottom navigation when screen is small
        <v-bottom-navigation
        class="homepage-settings-bottom-nav-drawer"
            absolute
            grow
            v-model="bottomNav"
            background-color="primary"
        >
            <v-btn
              v-for="(item, i) in items"
              :key="item.key"
              :to="item.to"
              color="primary"
              replace
            >
                <span :class="i === bottomNav? 'white--text' : ''">{{item.title}}</span>
            </v-btn>
        </v-bottom-navigation> -->


        <!-- Content section, where the currently chosen menu item content shows -->
        <section class="flex-grow">
            <main id="scroll-container">
              <v-container class="pt-16">
                <keep-alive>
                  <component :is="currentComponent"></component>
                </keep-alive>
              </v-container>
            </main>
        </section>
    </v-container>
</template>
<script>

import HomepageSelector from './sections/HomepageSelector'

const scrollActiveItemClass = '.scrollactive-item'
const activeSectionClass = '.active-section'
export default {
    components: { HomepageSelector },
    props: {
        navigation: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            navDrawer: true,
            bottomNav: false,
            activeScroll: {
                alwaysTrack: false,
                duration: 600,
                clicktoScroll: true,
                offset: 110,
                scrollContainerSelector: '#scroll-container',
                modifyUrl: false,
                activeClass: 'active-subsection'
            },

            items: [
                {
                    key: 'innstillinger',
                    title: 'Hjemmesider',
                    to: {
                        title: 'homepage-selector',
                        params: { section: 'innstillinger', subsection: null }
                    },
                    component: HomepageSelector,
                    items: [
                        {
                            title: 'Alle hjemmesider',
                            to: {
                                title: 'homepage-selector',
                                params: { section: 'innstillinger', subsection: 'Alle-hjemmesider' }
                            }
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        section () {
            return this.navigation.section
        },
        currentComponent () {
            let item = this.items.find((i) => i.key === this.navigation.section)
            return item.component || this.items[0].component // Fallback to first section component
        }
    },
    methods: {
        navigate (to) {
            if (to) {
              this.$router.replace(to)
            }
        },
        setFirstSubsectionActive () {
            this.$nextTick(() => {
              let elements = document.querySelectorAll(scrollActiveItemClass)
              for (let i = 0; i < elements.length; i++) {
                elements[i].classList.remove(this.activeScroll.activeClass)
              }
              let el = document.querySelector(
                `${activeSectionClass} ${scrollActiveItemClass}`
              )
              el && el.classList.add(this.activeScroll.activeClass)
            })
        }
    },
    mounted () {
        this.setFirstSubsectionActive()
    },
    watch: {
        section () {
            this.setFirstSubsectionActive()
        }
    }
}
</script>
<style lang="scss">
    .homepage-settings-content {
        display: flex;
        overflow: hidden;
        position: relative;
        height: calc(100% + 182px);
        width: 100%;
        gap: 10px;  
    }

    .homepage-settings-bottom-nav-drawer {
        display: none !important;
    }

    // .disable-events {
    //     pointer-events: none;
    //     opacity: 0.5;
    // }
    // @media screen and (min-width: 600px) {
    //     .v-main {
    //         overflow: hidden !important;
    //     }
    //     .scroll-container {
    //         overflow: hidden !important;
    //     }
    // }
    // @media screen and (max-width: 600px) {
    //     .scroll-container {
    //         overflow-y: auto !important;
    //     }
    // }

    .homepage-settings-nav-drawer {
        min-width: 300px;
        width: 300px !important;
        background-color: #ffffff !important;
        // z-index: 9999;
        // Vuetify overrides
        .v-list--dense .v-list-item .v-list-item__content {
            padding-left: 20px;
        }

        .active-section {
            .v-list-group__header.v-list-item {
                /* states.pressed */
                background: #c7e3e4 !important;
                color: #472449 !important;
                border-radius: 0px !important;
                .v-list-item__title {
                    font-weight: 500 !important;
                }
            }

            &.has-items {
                .v-list-group__header.v-list-item {
                    border-radius: 0px !important;
                    margin-bottom: 16px !important;
                }
            }

            .v-list-group__header.v-list-item:hover::before {
                opacity: 0;
            }
        }

        .v-list-group__header.v-list-item:hover {
            background: #c7e3e4 !important;
            color: #472449 !important;
            border-radius: 0px !important;
            // border-top-right-radius: 16px;
            // border-bottom-right-radius: 16px;
            border-radius: 0px !important;
        }
        .v-list-group__header.v-list-item:hover::before {
            opacity: 0;
        }

        .active-subsection {
            color: #472449 !important;
        }

        .theme--light.v-list-item--active:hover::before,
        .theme--light.v-list-item--active::before {
            opacity: 0;
        }

        .theme--light.v-list-item:hover::before {
            opacity: 0;
        }

        .v-list--dense .v-list-item .v-list-item__title {
            font-size: 14px;
            font-weight: normal;
        }

        .active-subsection {
            color: #472449 !important;
            .subsection-content {
                border-left: 2px solid #472449;
            }

            .v-list-item__title {
                font-weight: 500 !important;
            }
        }

        .subsection-content {
            padding-left: 16px !important;
            // border-left: 1px solid rgba(223, 242, 243, 1);
            min-height: 20px;
        }

        .v-list-item--dense,
        .v-list--dense .v-list-item {
            min-height: 20px;
        }

        .v-list--dense.v-list--nav
        .v-list-group--no-action
        > .v-list-group__items
        > .v-list-item {
            padding-left: 30px;
        }

        .v-list-group__items .v-list-item:last-child {
            margin-bottom: 20px !important;
        }
    }

    @media  (max-width: 1000px) {
        .homepage-settings-nav-drawer {
            display: none !important;
        }

        .homepage-settings-bottom-nav-drawer {
            display: initial !important;
        }
    }
</style>
